import React from 'react';
import './App.css';
import { DevelopmentForm } from '../Components/DevelopmentForm';

function App() {
  return (
    <div className="App">
      
      <DevelopmentForm />

    </div>
  );
}

export default App;
